<template>
		<div>
			<main style='background: #EEEEEE;'>
				<div class="fyBox">
					<!-- <div class="centerBox">
						<img src="../../assets/images/hj_banner.png" alt="" class="topImg">
					</div> -->
				</div>
				<div class="topContent">
					<div class="centerBox">
						<p class="topContent_word1">环境损害鉴定</p>
						<p class="topContent_word2"> 按照规定的程序和方法，综合运用科学技术和专业知识，调查污染环境、破坏生态行为与生态环境损害情况，分析污染环境或破坏生态行为与生态环境损害间的因果关系，评估污染环境或破坏生态行为所致生态环境损害的范围和程度，确定生态环境恢复至基线并补偿期间损害的恢复措施，量化生态环境损害数额，出具鉴定意见，为环境管理、环境司法等提供服务。</p>
					</div>
				</div>
				<div class="centerBox" style="padding:26px 0;">
					<p class="topContent_word1">鉴定机构列表</p>
					<div class="bottomContent">
                        <el-link href="http://www.zxsfjd.cn/" style="width: 35%; margin-top: 26px; font-size: 24px;text-decoration:underline;" type="primary" :underline="false"> 中旭生态环境损害司法鉴定中心 </el-link>
						<div class="bottomContent_top">
							<img src="../../assets/images/huanjing_logo.73c846db.jpg" alt="">
                            <!--<a href="http://www.zxsfjd.cn/">中旭生态环境损害司法鉴定中心</a>-->
								<p class="bottomContent_topWord">河北中旭生态环境损害司法鉴定中心成立于2019年1月，是河北省首家严格按照《环境损害司法鉴定机构登记评审细则》通过专家评审的环境损害司法鉴定机构。中心现有环境损害司法鉴定人33人，其中高级职称19人，80%具有硕士研究生以上学历。中心鉴定业务范围包括污染物性质鉴定、地表水和沉积物环境损害鉴定、空气污染环境损害鉴定、土壤与地下水环境损害鉴定、近海海洋与海岸带环境损害鉴定、生态系统环境损害鉴定、其他环境损害鉴定（噪声、振动）七大类全部生态环境损害鉴定类别。</p>
						</div>
						<div class="bottomContent_imgs">
							<img src="../../assets/images/huanjing_01.jpg" alt="">
							<img src="../../assets/images/hj_2.jpg" alt="">
							<img src="../../assets/images/hj_03.jpg" alt="">
							<img src="../../assets/images/hj_4.jpg" alt="">
						</div>
						<p v-for="(item, index) in jdfw" :key="index" class="fwxmItem">{{item}}</p>
						<!-- <div class="line"></div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省环境污染损害司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								沧州科技事务司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								承德保态林业司法鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								张家口鼎盛林业司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北农业司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								唐山物证司法鉴定中心
							</p>
						</div> -->
					</div>

				</div>
			</main>
		</div>
</template>

<script>

import axios from 'axios'
import '../../assets/css/index.less'
export default {
	name: 'Pdf',
	components: {
	},
	data() {
		return {
			jdfw:[
                '鉴定项目',
				'污染物性质鉴定',
				'地表水和沉积物环境损害鉴定',
				'空气污染环境损害鉴定',
				'土壤与地下水环境损害鉴定',
				'近海海洋与海岸带环境损害鉴定',
				'生态系统环境损害鉴定',
				'其他环境损害鉴定（噪声、振动）',
			],
			fayuanName: '河南省高级人民法院',
		};
	},
	methods: {
	},
	created(){

	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.fyBox{
		width: 100%;
		height: 340px;
		box-sizing: border-box;
		background: url(../../assets/images/hj_banner.png)no-repeat center;
		img{
			width: 100%;
			height: 300px;
			display: block;
			margin: 0 auto;
		}
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.topContent_word1{
		// width: 66px;
		height: 30px;
		float: left;
		line-height: 30px;
		border-bottom: 4px solid  #3DADC6;
	}
	.topContent_word2{
		margin-top: 12px;
		text-indent: 30px;
		width: 100%;
		float: left;
		text-align: justify;
		font-family: PingFangRegular;
		font-size: 16px;
		color: #000000;
		text-align: left;
		line-height: 28px;
	}

	.topContent{
		width: 100%;
		background: #fff;
		padding: 26px 0;
		box-sizing: border-box;
		overflow: hidden;
	}
	.bottomContent{
		width: 100%;
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		float: left;
		margin-top: 25px;
		padding-bottom: 60px;
	}
	.bottomContent_top{
		width: 100%;
		overflow: hidden;
		display: flex;
		    align-items: center;
		    margin-bottom: 15px;
		img{
			float: left;
		}
		.bottomContent_topWord{
			float: right;
			width: calc(100% - 350px);
			font-family: PingFangRegular;
			font-size: 16px;
			color: #000000;
			text-align: left;
			line-height: 28px;
			text-indent: 30px;
			text-align: justify;

		}
	}
	.bottomContent_imgs{
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
		img{
			width: 23%;
			display: block;
			float: left;
			margin-right: 25px;
			&:last-of-type{
				margin-right: 0;
			}
		}
	}
	.fwxmItem{
		    /* width: 13%; */
		    padding: 0 10px;
		    height: 32px;
		    line-height: 32px;
		    background: #90BC66;
		    border-radius: 5px;
		    text-align: center;
		    float: left;
		    font-size: 16px;
		    color: #fff;
		    margin-right: 15px;
		    box-sizing: border-box;
		    margin-bottom: 10px;
		&:first-of-type{
			background: none;
			color: #000;
		}
		&:last-of-type{
			margin-right: 0;
		}
	}
	.line{
		width: 100%;
		border-bottom: 2px dashed  #979797;
		margin:20px 0;
		float: left;
		margin-top: 40px;
	}
	.bottomWorditems{
		width: 100%;
		border-bottom: 1px dashed  #979797;
		overflow: hidden;
		.bottomWorditem{
			width: 33%;
			height: 47px;
			line-height: 47px;
			float: left;
			display: flex;
			align-items: center;
			img{
				float: left;
				margin-right: 10px;
			}
		}
	}
</style>
